<template>
  <div class="layout-no-padding">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.layout-no-padding {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
